// extracted by mini-css-extract-plugin
module.exports = {"appointment":"appointment-request_appointment__X1NUy","description":"appointment-request_description__sYdh2"};